// Full content mapping for all 58 pages of billundvvs.netlify.app

export const pagesData = {
  // 1. Home / Forside
  'index': {
    slug: 'index',
    route: '/',
    lang: 'da',
    title: 'VVS Billund – autoriseret VVS-installatør siden 1963',
    meta: {
      description: 'Autoriseret VVS-installatør i Billund Kommune. VVS, varmepumper, fjernvarme, bad, blikkenslager og døgnvagt. Gratis tilbud – ring 75 33 12 76.',
      ogTitle: 'VVS Billund – autoriseret VVS-installatør siden 1963',
      ogDescription: 'Autoriseret VVS-installatør i Billund Kommune. VVS, varmepumper, fjernvarme, bad, blikkenslager og døgnvagt. Gratis tilbud – ring 75 33 12 76.'
    }
  },

  // 2. EN Home
  'en': {
    slug: 'en',
    route: '/en',
    lang: 'en',
    title: 'Plumber Billund – authorised plumbing & heating since 1963',
    meta: {
      description: 'Authorised plumbing and heating contractor in Billund, Denmark. Plumbing, heat pumps, district heating, bathrooms, roof sheet metal and 24/7 emergency service. Call +45 75 33 12 76.',
      ogTitle: 'Plumber Billund – authorised plumbing & heating since 1963',
      ogDescription: 'Authorised plumbing and heating contractor in Billund, Denmark. Plumbing, heat pumps, district heating, bathrooms, roof sheet metal and 24/7 emergency service. Call +45 75 33 12 76.'
    }
  },

  // 3. Tilbud
  'tilbud': {
    slug: 'tilbud',
    route: '/tilbud',
    lang: 'da',
    title: 'Få et gratis VVS-tilbud i Billund | Billund VVS',
    meta: {
      description: 'Få et gratis, uforpligtende tilbud på VVS, varmepumpe, badeværelse eller blikkenslagerarbejde i Billund og omegn. Vi ringer tilbage inden for 24 timer.',
      ogTitle: 'Få et gratis VVS-tilbud i Billund | Billund VVS',
      ogDescription: 'Få et gratis, uforpligtende tilbud på VVS, varmepumpe, badeværelse eller blikkenslagerarbejde i Billund og omegn. Vi ringer tilbage inden for 24 timer.'
    }
  },

  // 4. EN Get a quote
  'en-get-a-quote': {
    slug: 'en-get-a-quote',
    route: '/en/get-a-quote',
    lang: 'en',
    title: 'Get a free plumbing quote in Billund | Billund VVS',
    meta: {
      description: 'Get a free, no-obligation quote for plumbing, a heat pump, a bathroom or sheet-metal work in Billund and the surrounding area. We call you back within 24 hours.',
      ogTitle: 'Get a free plumbing quote in Billund | Billund VVS',
      ogDescription: 'Get a free, no-obligation quote for plumbing, a heat pump, a bathroom or sheet-metal work in Billund and the surrounding area. We call you back within 24 hours.'
    }
  },

  // 5. Kontakt
  'kontakt': {
    slug: 'kontakt',
    route: '/kontakt',
    lang: 'da',
    title: 'Kontakt Billund Varme & Sanitet – ring 75 33 12 76',
    meta: {
      description: 'Kontakt din lokale VVS-installatør i Billund. Montanavej 1B, 7190 Billund. Tlf. 75 33 12 76, info@billundvvs.dk. Døgnvagt alle dage. Åbent man–tors 7–16.',
      ogTitle: 'Kontakt Billund Varme & Sanitet – ring 75 33 12 76',
      ogDescription: 'Kontakt din lokale VVS-installatør i Billund. Montanavej 1B, 7190 Billund. Tlf. 75 33 12 76, info@billundvvs.dk. Døgnvagt alle dage. Åbent man–tors 7–16.'
    }
  },

  // 6. EN Contact
  'en-contact': {
    slug: 'en-contact',
    route: '/en/contact',
    lang: 'en',
    title: 'Contact Billund Varme & Sanitet – call +45 75 33 12 76',
    meta: {
      description: 'Contact your local plumbing and heating contractor in Billund. Montanavej 1B, 7190 Billund. Tel. +45 75 33 12 76, info@billundvvs.dk. Emergency service every day. Open Mon–Thu 7–16.',
      ogTitle: 'Contact Billund Varme & Sanitet – call +45 75 33 12 76',
      ogDescription: 'Contact your local plumbing and heating contractor in Billund. Montanavej 1B, 7190 Billund. Tel. +45 75 33 12 76, info@billundvvs.dk. Emergency service every day. Open Mon–Thu 7–16.'
    }
  },

  // 7. Om os
  'om-os': {
    slug: 'om-os',
    route: '/om-os',
    lang: 'da',
    title: 'Om Billund Varme & Sanitet A/S – VVS siden 1963',
    meta: {
      description: 'Autoriseret VVS-installatør i Billund siden 1963, ejet af Mogens Brøgger siden 2012. Erfarne montører, lokal forankring og fokus på tilfredse kunder.',
      ogTitle: 'Om Billund Varme & Sanitet A/S – VVS siden 1963',
      ogDescription: 'Autoriseret VVS-installatør i Billund siden 1963, ejet af Mogens Brøgger siden 2012. Erfarne montører, lokal forankring og fokus på tilfredse kunder.'
    }
  },

  // 8. EN About
  'en-about': {
    slug: 'en-about',
    route: '/en/about',
    lang: 'en',
    title: 'About Billund Varme & Sanitet A/S – plumbing since 1963',
    meta: {
      description: 'Authorised plumbing and heating contractor in Billund since 1963, owned by Mogens Brøgger since 2012. Experienced technicians, local roots and a focus on satisfied customers.',
      ogTitle: 'About Billund Varme & Sanitet A/S – plumbing since 1963',
      ogDescription: 'Authorised plumbing and heating contractor in Billund since 1963, owned by Mogens Brøgger since 2012. Experienced technicians, local roots and a focus on satisfied customers.'
    }
  },

  // 9. Blikkenslager
  'blikkenslager': {
    slug: 'blikkenslager',
    route: '/blikkenslager',
    lang: 'da',
    title: 'Blikkenslager Billund – tagrender & inddækninger',
    meta: {
      description: 'Blikkenslagerarbejde i Billund og omegn: tagrender, nedløb, inddækninger, skotrender og zink- og kobberarbejde. Autoriseret firma siden 1963.',
      ogTitle: 'Blikkenslager Billund – tagrender & inddækninger',
      ogDescription: 'Blikkenslagerarbejde i Billund og omegn: tagrender, nedløb, inddækninger, skotrender og zink- og kobberarbejde. Autoriseret firma siden 1963.'
    }
  },

  // 10. EN Sheet metal
  'en-sheet-metal': {
    slug: 'en-sheet-metal',
    route: '/en/sheet-metal',
    lang: 'en',
    title: 'Roof sheet metal Billund – gutters & flashings',
    meta: {
      description: 'Sheet-metal work in Billund and the surrounding area: gutters, downpipes, flashings, valley gutters and zinc and copper work. Authorised plumbing and sheet-metal firm since 1963.',
      ogTitle: 'Roof sheet metal Billund – gutters & flashings',
      ogDescription: 'Sheet-metal work in Billund and the surrounding area: gutters, downpipes, flashings, valley gutters and zinc and copper work. Authorised plumbing and sheet-metal firm since 1963.'
    }
  },

  // 11. Nybyggeri
  'nybyggeri': {
    slug: 'nybyggeri',
    route: '/nybyggeri',
    lang: 'da',
    title: 'VVS i nybyggeri – bolig, erhverv & institutioner',
    meta: {
      description: 'Komplette VVS-installationer i nybyggeri i Billund og Trekantområdet: parcelhuse, rækkehuse, erhverv og institutioner. Fast partner for entreprenører.',
      ogTitle: 'VVS i nybyggeri – bolig, erhverv & institutioner',
      ogDescription: 'Komplette VVS-installationer i nybyggeri i Billund og Trekantområdet: parcelhuse, rækkehuse, erhverv og institutioner. Fast partner for entreprenører.'
    }
  },

  // 12. EN New construction
  'en-new-construction': {
    slug: 'en-new-construction',
    route: '/en/new-construction',
    lang: 'en',
    title: 'Plumbing for new construction – homes, commercial & public',
    meta: {
      description: 'Complete plumbing, heating and ventilation for new builds in Billund and the Triangle Region: houses, terraced housing, commercial buildings and institutions. Trusted partner for contractors.',
      ogTitle: 'Plumbing for new construction – homes, commercial & public',
      ogDescription: 'Complete plumbing, heating and ventilation for new builds in Billund and the Triangle Region: houses, terraced housing, commercial buildings and institutions. Trusted partner for contractors.'
    }
  },

  // 13. Erhverv
  'erhverv': {
    slug: 'erhverv',
    route: '/erhverv',
    lang: 'da',
    title: 'VVS til erhverv & boligforeninger i Billund',
    meta: {
      description: 'VVS-partner for virksomheder, boligforeninger og institutioner i Billund Kommune. Serviceaftaler, drift, renovering og hurtig udrykning ved driftstop.',
      ogTitle: 'VVS til erhverv & boligforeninger i Billund',
      ogDescription: 'VVS-partner for virksomheder, boligforeninger og institutioner i Billund Kommune. Serviceaftaler, drift, renovering og hurtig udrykning ved driftstop.'
    }
  },

  // 14. EN Commercial
  'en-commercial': {
    slug: 'en-commercial',
    route: '/en/commercial',
    lang: 'en',
    title: 'Plumbing for business & housing associations in Billund',
    meta: {
      description: 'Plumbing and heating partner for companies, housing associations and public institutions in Billund Municipality. Service agreements, operation, renovation and fast response to breakdowns.',
      ogTitle: 'Plumbing for business & housing associations in Billund',
      ogDescription: 'Plumbing and heating partner for companies, housing associations and public institutions in Billund Municipality. Service agreements, operation, renovation and fast response to breakdowns.'
    }
  },

  // 15. Referencer
  'referencer': {
    slug: 'referencer',
    route: '/referencer',
    lang: 'da',
    title: 'Referencer – VVS-projekter i Billund & omegn',
    meta: {
      description: 'Se eksempler på projekter fra Billund Varme & Sanitet: badeværelser, varmepumper, nybyggeri, erhverv og institutioner i Billund, Grindsted, Give og Vejle.',
      ogTitle: 'Referencer – VVS-projekter i Billund & omegn',
      ogDescription: 'Se eksempler på projekter fra Billund Varme & Sanitet: badeværelser, varmepumper, nybyggeri, erhverv og institutioner i Billund, Grindsted, Give og Vejle.'
    }
  },

  // 16. EN References
  'en-references': {
    slug: 'en-references',
    route: '/en/references',
    lang: 'en',
    title: 'References – plumbing projects in Billund & area',
    meta: {
      description: 'See examples of projects by Billund Varme & Sanitet: bathrooms, heat pumps, new builds, commercial and institutions in Billund, Grindsted, Give and Vejle.',
      ogTitle: 'References – plumbing projects in Billund & area',
      ogDescription: 'See examples of projects by Billund Varme & Sanitet: bathrooms, heat pumps, new builds, commercial and institutions in Billund, Grindsted, Give and Vejle.'
    }
  },

  // 17. Karriere
  'karriere': {
    slug: 'karriere',
    route: '/karriere',
    lang: 'da',
    title: 'Job & lærlingeplads som VVS\'er i Billund',
    meta: {
      description: 'Vil du være VVS-montør eller VVS-lærling i Billund? Vi søger løbende dygtige montører og lærlinge til et lokalt firma med varierede opgaver siden 1963.',
      ogTitle: 'Job & lærlingeplads som VVS\'er i Billund',
      ogDescription: 'Vil du være VVS-montør eller VVS-lærling i Billund? Vi søger løbende dygtige montører og lærlinge til et lokalt firma med varierede opgaver siden 1963.'
    }
  },

  // 18. EN Careers
  'en-careers': {
    slug: 'en-careers',
    route: '/en/careers',
    lang: 'en',
    title: 'Jobs & apprenticeships as a plumber in Billund',
    meta: {
      description: 'Want to work as a plumber or plumbing apprentice in Billund? Billund Varme & Sanitet is always looking for skilled technicians and apprentices. Good working environment, varied jobs, local firm since 1963.',
      ogTitle: 'Jobs & apprenticeships as a plumber in Billund',
      ogDescription: 'Want to work as a plumber or plumbing apprentice in Billund? Billund Varme & Sanitet is always looking for skilled technicians and apprentices. Good working environment, varied jobs, local firm since 1963.'
    }
  },

  // 19. FAQ
  'faq': {
    slug: 'faq',
    route: '/faq',
    lang: 'da',
    title: 'Ofte stillede spørgsmål om VVS & varme | Billund VVS',
    meta: {
      description: 'Hvad koster en VVS\'er? Hvornår skal fyret skiftes? Dækker forsikringen? Få svar fra en autoriseret VVS-installatør i Billund på de mest stillede spørgsmål.',
      ogTitle: 'Ofte stillede spørgsmål om VVS & varme | Billund VVS',
      ogDescription: 'Hvad koster en VVS\'er? Hvornår skal fyret skiftes? Dækker forsikringen? Få svar fra en autoriseret VVS-installatør i Billund på de mest stillede spørgsmål.'
    }
  },

  // 20. EN FAQ
  'en-faq': {
    slug: 'en-faq',
    route: '/en/faq',
    lang: 'en',
    title: 'Frequently asked questions about plumbing & heating',
    meta: {
      description: 'What does a plumber cost? When should I replace my boiler? Does insurance cover it? Answers from an authorised plumbing installer in Billund to the most common questions.',
      ogTitle: 'Frequently asked questions about plumbing & heating',
      ogDescription: 'What does a plumber cost? When should I replace my boiler? Does insurance cover it? Answers from an authorised plumbing installer in Billund to the most common questions.'
    }
  },

  // 21. Privatlivspolitik
  'privatlivspolitik': {
    slug: 'privatlivspolitik',
    route: '/privatlivspolitik',
    lang: 'da',
    title: 'Privatlivspolitik | Billund Varme & Sanitet A/S',
    meta: {
      description: 'Læs, hvordan Billund Varme & Sanitet A/S behandler personoplysninger fra kunder, henvendelser via hjemmesiden og cookies.',
      ogTitle: 'Privatlivspolitik | Billund Varme & Sanitet A/S',
      ogDescription: 'Læs, hvordan Billund Varme & Sanitet A/S behandler personoplysninger fra kunder, henvendelser via hjemmesiden og cookies.'
    }
  },

  // 22. EN Privacy policy
  'en-privacy-policy': {
    slug: 'en-privacy-policy',
    route: '/en/privacy-policy',
    lang: 'en',
    title: 'Privacy policy | Billund Varme & Sanitet A/S',
    meta: {
      description: 'Read how Billund Varme & Sanitet A/S processes personal data from customers, enquiries via the website and cookies.',
      ogTitle: 'Privacy policy | Billund Varme & Sanitet A/S',
      ogDescription: 'Read how Billund Varme & Sanitet A/S processes personal data from customers, enquiries via the website and cookies.'
    }
  },

  // 23. Service og vedligehold
  'service-og-vedligehold': {
    slug: 'service-og-vedligehold',
    route: '/service-og-vedligehold',
    lang: 'da',
    title: 'VVS-service & serviceaftaler Billund | Billund VVS',
    meta: {
      description: 'Serviceaftale på varmepumpe, fjernvarme, gasfyr og ventilation i Billund og omegn. Årligt eftersyn, lavere driftsomkostninger og længere levetid.',
      ogTitle: 'VVS-service & serviceaftaler Billund | Billund VVS',
      ogDescription: 'Serviceaftale på varmepumpe, fjernvarme, gasfyr og ventilation i Billund og omegn. Årligt eftersyn, lavere driftsomkostninger og længere levetid.'
    }
  },

  // 24. EN Service maintenance
  'en-service-maintenance': {
    slug: 'en-service-maintenance',
    route: '/en/service-maintenance',
    lang: 'en',
    title: 'Plumbing service & service agreements Billund | Billund VVS',
    meta: {
      description: 'Service agreements for heat pumps, district heating, gas boilers and ventilation in Billund and the surrounding area. Annual inspection, lower running costs and longer lifetime.',
      ogTitle: 'Plumbing service & service agreements Billund | Billund VVS',
      ogDescription: 'Service agreements for heat pumps, district heating, gas boilers and ventilation in Billund and the surrounding area. Annual inspection, lower running costs and longer lifetime.'
    }
  },

  // 25. VVS
  'vvs': {
    slug: 'vvs',
    route: '/vvs',
    lang: 'da',
    title: 'VVS-installatør Billund – alle VVS-ydelser | Billund VVS',
    meta: {
      description: 'Autoriseret VVS-installatør i Billund med 60+ års erfaring. Rør, bad, varme, ventilation og akut VVS. Fast pris på tilbud – ring 75 33 12 76.',
      ogTitle: 'VVS-installatør Billund – alle VVS-ydelser | Billund VVS',
      ogDescription: 'Autoriseret VVS-installatør i Billund med 60+ års erfaring. Rør, bad, varme, ventilation og akut VVS. Fast pris på tilbud – ring 75 33 12 76.'
    }
  },

  // 26. EN Plumbing
  'en-plumbing': {
    slug: 'en-plumbing',
    route: '/en/plumbing',
    lang: 'en',
    title: 'Plumber in Billund – all plumbing services | Billund VVS',
    meta: {
      description: 'Authorised plumber in Billund with 60+ years of experience. Pipework, bathrooms, heating, ventilation and emergency plumbing. Fixed-price quotes – call +45 75 33 12 76.',
      ogTitle: 'Plumber in Billund – all plumbing services | Billund VVS',
      ogDescription: 'Authorised plumber in Billund with 60+ years of experience. Pipework, bathrooms, heating, ventilation and emergency plumbing. Fixed-price quotes – call +45 75 33 12 76.'
    }
  },

  // 27. Badeværelser
  'vvs-badevaerelser': {
    slug: 'vvs-badevaerelser',
    route: '/vvs/badevaerelser',
    lang: 'da',
    title: 'Nyt badeværelse Billund – renovering til fast pris',
    meta: {
      description: 'Nyt badeværelse i Billund, Grindsted eller Give? Totalrenovering med VVS, el, murer og fliser til fast pris. Gratis besigtigelse – ring 75 33 12 76.',
      ogTitle: 'Nyt badeværelse Billund – renovering til fast pris',
      ogDescription: 'Nyt badeværelse i Billund, Grindsted eller Give? Totalrenovering med VVS, el, murer og fliser til fast pris. Gratis besigtigelse – ring 75 33 12 76.'
    }
  },

  // 28. EN Bathrooms
  'en-plumbing-bathrooms': {
    slug: 'en-plumbing-bathrooms',
    route: '/en/plumbing/bathrooms',
    lang: 'en',
    title: 'New bathroom in Billund – renovation at a fixed price',
    meta: {
      description: 'Dreaming of a new bathroom? We renovate bathrooms in Billund, Grindsted and Give – full turnkey service with plumbing, electrics, tiling and fittings at a fixed price.',
      ogTitle: 'New bathroom in Billund – renovation at a fixed price',
      ogDescription: 'Dreaming of a new bathroom? We renovate bathrooms in Billund, Grindsted and Give – full turnkey service with plumbing, electrics, tiling and fittings at a fixed price.'
    }
  },

  // 29. Rørinstallationer
  'vvs-roerinstallationer': {
    slug: 'vvs-roerinstallationer',
    route: '/vvs/roerinstallationer',
    lang: 'da',
    title: 'Rørinstallationer & vandskader Billund | Billund VVS',
    meta: {
      description: 'Utætte rør, gamle vandrør eller vandskade? Vi renoverer rørinstallationer i Billund og omegn og rykker ud døgnet rundt ved skader. Ring 75 33 12 76.',
      ogTitle: 'Rørinstallationer & vandskader Billund | Billund VVS',
      ogDescription: 'Utætte rør, gamle vandrør eller vandskade? Vi renoverer rørinstallationer i Billund og omegn og rykker ud døgnet rundt ved skader. Ring 75 33 12 76.'
    }
  },

  // 30. EN Pipework
  'en-plumbing-pipework-water-damage': {
    slug: 'en-plumbing-pipework-water-damage',
    route: '/en/plumbing/pipework-water-damage',
    lang: 'en',
    title: 'Pipework and water damage in Billund | Billund VVS',
    meta: {
      description: 'Leaking pipes, old water installations or water damage? We replace and renovate pipework in Billund and the surrounding area – and are on call 24/7 for emergencies. Call +45 75 33 12 76.',
      ogTitle: 'Pipework and water damage in Billund | Billund VVS',
      ogDescription: 'Leaking pipes, old water installations or water damage? We replace and renovate pipework in Billund and the surrounding area – and are on call 24/7 for emergencies. Call +45 75 33 12 76.'
    }
  },

  // 31. Ventilation
  'vvs-ventilation': {
    slug: 'vvs-ventilation',
    route: '/vvs/ventilation',
    lang: 'da',
    title: 'Ventilation & indeklima Billund – installation | Billund VVS',
    meta: {
      description: 'Fugt, skimmel eller dårlig luft? Vi installerer og servicerer ventilationsanlæg med varmegenvinding i bolig og erhverv i Billund Kommune. Få et tilbud.',
      ogTitle: 'Ventilation & indeklima Billund – installation | Billund VVS',
      ogDescription: 'Fugt, skimmel eller dårlig luft? Vi installerer og servicerer ventilationsanlæg med varmegenvinding i bolig og erhverv i Billund Kommune. Få et tilbud.'
    }
  },

  // 32. EN Ventilation
  'en-plumbing-ventilation': {
    slug: 'en-plumbing-ventilation',
    route: '/en/plumbing/ventilation',
    lang: 'en',
    title: 'Ventilation & indoor climate in Billund | Billund VVS',
    meta: {
      description: 'Damp, mould or stale air? We install and service ventilation systems with heat recovery for homes and businesses in Billund Municipality. Get a quote.',
      ogTitle: 'Ventilation & indoor climate in Billund | Billund VVS',
      ogDescription: 'Damp, mould or stale air? We install and service ventilation systems with heat recovery for homes and businesses in Billund Municipality. Get a quote.'
    }
  },

  // 33. Akut VVS
  'vvs-akut-vvs': {
    slug: 'vvs-akut-vvs',
    route: '/vvs/akut-vvs',
    lang: 'da',
    title: 'Akut VVS Billund – døgnvagt 24/7 | Ring 75 33 12 76',
    meta: {
      description: 'Sprængt rør, stoppet afløb eller ingen varme? Akut VVS-hjælp i Billund, Grindsted, Give og Vejle – døgnet rundt, alle dage. Ring 75 33 12 76 nu.',
      ogTitle: 'Akut VVS Billund – døgnvagt 24/7 | Ring 75 33 12 76',
      ogDescription: 'Sprængt rør, stoppet afløb eller ingen varme? Akut VVS-hjælp i Billund, Grindsted, Give og Vejle – døgnet rundt, alle dage. Ring 75 33 12 76 nu.'
    }
  },

  // 34. EN Emergency
  'en-plumbing-emergency': {
    slug: 'en-plumbing-emergency',
    route: '/en/plumbing/emergency',
    lang: 'en',
    title: 'Emergency plumber Billund – 24/7 | Call +45 75 33 12 76',
    meta: {
      description: 'Burst pipe, blocked drain or no heating? Emergency plumbing in Billund, Grindsted, Give and Vejle – around the clock, every day. Call +45 75 33 12 76 now.',
      ogTitle: 'Emergency plumber Billund – 24/7 | Call +45 75 33 12 76',
      ogDescription: 'Burst pipe, blocked drain or no heating? Emergency plumbing in Billund, Grindsted, Give and Vejle – around the clock, every day. Call +45 75 33 12 76 now.'
    }
  },

  // 35. Varmepumper
  'varme-varmepumper': {
    slug: 'varme-varmepumper',
    route: '/varme/varmepumper',
    lang: 'da',
    title: 'Varmepumpe Billund – installation, tilskud og service',
    meta: {
      description: 'Skift til varmepumpe i Billund og spar op til 60 % på varmen. Vi rådgiver, søger tilskud og installerer luft til vand-varmepumper til fast pris.',
      ogTitle: 'Varmepumpe Billund – installation, tilskud og service',
      ogDescription: 'Skift til varmepumpe i Billund og spar op til 60 % på varmen. Vi rådgiver, søger tilskud og installerer luft til vand-varmepumper til fast pris.'
    }
  },

  // 36. EN Heat pumps
  'en-heating-heat-pumps': {
    slug: 'en-heating-heat-pumps',
    route: '/en/heating/heat-pumps',
    lang: 'en',
    title: 'Heat pump Billund – installation, grants and service',
    meta: {
      description: 'Switch to a heat pump in Billund and save up to 60 % on heating. We advise, apply for grants and install air-to-water heat pumps at a fixed price with a service agreement.',
      ogTitle: 'Heat pump Billund – installation, grants and service',
      ogDescription: 'Switch to a heat pump in Billund and save up to 60 % on heating. We advise, apply for grants and install air-to-water heat pumps at a fixed price with a service agreement.'
    }
  },

  // 37. Fjernvarme
  'varme-fjernvarme': {
    slug: 'varme-fjernvarme',
    route: '/varme/fjernvarme',
    lang: 'da',
    title: 'Fjernvarme Billund – tilslutning & fjernvarmeunit',
    meta: {
      description: 'Skal du tilsluttes fjernvarme i Billund eller Grindsted? Vi monterer fjernvarmeunit, fjerner det gamle fyr og optimerer anlægget. Få et tilbud.',
      ogTitle: 'Fjernvarme Billund – tilslutning & fjernvarmeunit',
      ogDescription: 'Skal du tilsluttes fjernvarme i Billund eller Grindsted? Vi monterer fjernvarmeunit, fjerner det gamle fyr og optimerer anlægget. Få et tilbud.'
    }
  },

  // 38. EN District heating
  'en-heating-district-heating': {
    slug: 'en-heating-district-heating',
    route: '/en/heating/district-heating',
    lang: 'en',
    title: 'District heating Billund – connection & heat unit',
    meta: {
      description: 'Connecting to district heating in Billund or Grindsted? We install the district heating unit, remove the old boiler and optimise your system to avoid high return temperatures. Get a quote.',
      ogTitle: 'District heating Billund – connection & heat unit',
      ogDescription: 'Connecting to district heating in Billund or Grindsted? We install the district heating unit, remove the old boiler and optimise your system to avoid high return temperatures. Get a quote.'
    }
  },

  // 39. Varmeanlæg
  'varme-varmeanlaeg': {
    slug: 'varme-varmeanlaeg',
    route: '/varme/varmeanlaeg',
    lang: 'da',
    title: 'Varmeanlæg, gulvvarme & udskiftning af fyr Billund',
    meta: {
      description: 'Nyt varmeanlæg, gulvvarme, radiatorer eller udskiftning af gas- og oliefyr i Billund og omegn. Autoriseret installatør siden 1963. Ring 75 33 12 76.',
      ogTitle: 'Varmeanlæg, gulvvarme & udskiftning af fyr Billund',
      ogDescription: 'Nyt varmeanlæg, gulvvarme, radiatorer eller udskiftning af gas- og oliefyr i Billund og omegn. Autoriseret installatør siden 1963. Ring 75 33 12 76.'
    }
  },

  // 40. EN Heating systems
  'en-heating-heating-systems': {
    slug: 'en-heating-heating-systems',
    route: '/en/heating/heating-systems',
    lang: 'en',
    title: 'Heating systems, underfloor heating & boiler replacement',
    meta: {
      description: 'New heating system, underfloor heating, radiators or replacement of gas and oil boilers in Billund and the surrounding area. Authorised installer with 60+ years of experience.',
      ogTitle: 'Heating systems, underfloor heating & boiler replacement',
      ogDescription: 'New heating system, underfloor heating, radiators or replacement of gas and oil boilers in Billund and the surrounding area. Authorised installer with 60+ years of experience.'
    }
  },

  // 41. Guides oversigt
  'guides': {
    slug: 'guides',
    route: '/guides',
    lang: 'da',
    title: 'Guides & gode råd om VVS og varme | Billund VVS',
    meta: {
      description: 'Gode råd fra VVS-fagmanden i Billund: priser på varmepumper, fjernvarme kontra varmepumpe, frostsikring af rør og andre guides til husejere.',
      ogTitle: 'Guides & gode råd om VVS og varme | Billund VVS',
      ogDescription: 'Gode råd fra VVS-fagmanden i Billund: priser på varmepumper, fjernvarme kontra varmepumpe, frostsikring af rør og andre guides til husejere.'
    }
  },

  // 42. EN Guides
  'en-guides': {
    slug: 'en-guides',
    route: '/en/guides',
    lang: 'en',
    title: 'Guides & advice on plumbing and heating | Billund VVS',
    meta: {
      description: 'Good advice from the plumbing professionals in Billund: what a heat pump costs, district heating versus heat pumps, frost-protecting pipes and other guides for homeowners.',
      ogTitle: 'Guides & advice on plumbing and heating | Billund VVS',
      ogDescription: 'Good advice from the plumbing professionals in Billund: what a heat pump costs, district heating versus heat pumps, frost-protecting pipes and other guides for homeowners.'
    }
  },

  // 43. Guide: Hvad koster en varmepumpe
  'guides-hvad-koster-en-varmepumpe': {
    slug: 'guides-hvad-koster-en-varmepumpe',
    route: '/guides/hvad-koster-en-varmepumpe',
    lang: 'da',
    title: 'Hvad koster en varmepumpe i 2026? Priser & tilskud',
    meta: {
      description: 'Hvad koster en luft til vand-varmepumpe installeret i et parcelhus? Se priser, tilskud, driftsomkostninger og tilbagebetalingstid – forklaret af VVS\'eren.',
      ogTitle: 'Hvad koster en varmepumpe i 2026? Priser & tilskud',
      ogDescription: 'Hvad koster en luft til vand-varmepumpe installeret i et parcelhus? Se priser, tilskud, driftsomkostninger og tilbagebetalingstid – forklaret af VVS\'eren.'
    }
  },

  // 44. EN Guide: Heat pump cost
  'en-guides-heat-pump-cost': {
    slug: 'en-guides-heat-pump-cost',
    route: '/en/guides/heat-pump-cost',
    lang: 'en',
    title: 'What does a heat pump cost? Price factors & grants',
    meta: {
      description: 'What does an air-to-water heat pump cost installed in a Danish house? See what affects the price, which grants apply, running costs and payback – explained by the installer in Billund.',
      ogTitle: 'What does a heat pump cost? Price factors & grants',
      ogDescription: 'What does an air-to-water heat pump cost installed in a Danish house? See what affects the price, which grants apply, running costs and payback – explained by the installer in Billund.'
    }
  },

  // 45. Guide: Frostsprængte rør
  'guides-frostspraengte-roer': {
    slug: 'guides-frostspraengte-roer',
    route: '/guides/frostspraengte-roer',
    lang: 'da',
    title: 'Sådan undgår du frostsprængte rør – 5 råd fra VVS\'eren',
    meta: {
      description: 'Frostsprængte rør er vinterens dyreste skade. Fem konkrete råd til at frostsikre vandrør, udendørs haner og sommerhuse – og hvad du gør, hvis skaden sker.',
      ogTitle: 'Sådan undgår du frostsprængte rør – 5 råd fra VVS\'eren',
      ogDescription: 'Frostsprængte rør er vinterens dyreste skade. Fem konkrete råd til at frostsikre vandrør, udendørs haner og sommerhuse – og hvad du gør, hvis skaden sker.'
    }
  },

  // 46. EN Guide: Frozen pipes
  'en-guides-frozen-pipes': {
    slug: 'en-guides-frozen-pipes',
    route: '/en/guides/frozen-pipes',
    lang: 'en',
    title: 'How to avoid frozen pipes – 5 tips from the plumber',
    meta: {
      description: 'Burst pipes are one of winter\'s most expensive damages. Five practical tips for frost-protecting water pipes, outdoor taps and holiday homes – and what to do if the damage is done.',
      ogTitle: 'How to avoid frozen pipes – 5 tips from the plumber',
      ogDescription: 'Burst pipes are one of winter\'s most expensive damages. Five practical tips for frost-protecting water pipes, outdoor taps and holiday homes – and what to do if the damage is done.'
    }
  },

  // 47. Guide: Fjernvarme eller varmepumpe
  'guides-fjernvarme-eller-varmepumpe': {
    slug: 'guides-fjernvarme-eller-varmepumpe',
    route: '/guides/fjernvarme-eller-varmepumpe',
    lang: 'da',
    title: 'Fjernvarme eller varmepumpe? Sådan vælger du i Billund',
    meta: {
      description: 'Skal du vælge fjernvarme eller varmepumpe, når fyret skal ud? Vi sammenligner pris, drift, komfort og klima for husejere i Billund og Grindsted.',
      ogTitle: 'Fjernvarme eller varmepumpe? Sådan vælger du i Billund',
      ogDescription: 'Skal du vælge fjernvarme eller varmepumpe, når fyret skal ud? Vi sammenligner pris, drift, komfort og klima for husejere i Billund og Grindsted.'
    }
  },

  // 48. EN Guide: District heating or heat pump
  'en-guides-district-heating-or-heat-pump': {
    slug: 'en-guides-district-heating-or-heat-pump',
    route: '/en/guides/district-heating-or-heat-pump',
    lang: 'en',
    title: 'District heating or heat pump? How to choose in Billund',
    meta: {
      description: 'Choosing between district heating and a heat pump when the boiler has to go? We compare cost, operation, comfort and climate for homeowners in Billund and Grindsted – impartially and concretely.',
      ogTitle: 'District heating or heat pump? How to choose in Billund',
      ogDescription: 'Choosing between district heating and a heat pump when the boiler has to go? We compare cost, operation, comfort and climate for homeowners in Billund and Grindsted – impartially and concretely.'
    }
  },

  // 49. VVS Billund
  'vvs-billund': {
    slug: 'vvs-billund',
    route: '/vvs-billund',
    lang: 'da',
    title: 'VVS Billund – lokal VVS\'er på Montanavej siden 1963',
    meta: {
      description: 'Søger du en VVS\'er i Billund? Vi holder til på Montanavej 1B og har hjulpet byen siden 1963. VVS, varme, bad, blik og døgnvagt. Ring 75 33 12 76.',
      ogTitle: 'VVS Billund – lokal VVS\'er på Montanavej siden 1963',
      ogDescription: 'Søger du en VVS\'er i Billund? Vi holder til på Montanavej 1B og har hjulpet byen siden 1963. VVS, varme, bad, blik og døgnvagt. Ring 75 33 12 76.'
    }
  },

  // 50. EN Plumber Billund
  'en-plumber-billund': {
    slug: 'en-plumber-billund',
    route: '/en/plumber-billund',
    lang: 'en',
    title: 'Plumber Billund – local plumbing firm on Montanavej since 1963',
    meta: {
      description: 'Looking for a plumber in Billund? We are based at Montanavej 1B and have served Billund\'s residents and businesses since 1963. Plumbing, heating, bathrooms, sheet metal and 24/7 emergency service.',
      ogTitle: 'Plumber Billund – local plumbing firm on Montanavej since 1963',
      ogDescription: 'Looking for a plumber in Billund? We are based at Montanavej 1B and have served Billund\'s residents and businesses since 1963. Plumbing, heating, bathrooms, sheet metal and 24/7 emergency service.'
    }
  },

  // 51. VVS Grindsted
  'vvs-grindsted': {
    slug: 'vvs-grindsted',
    route: '/vvs-grindsted',
    lang: 'da',
    title: 'VVS Grindsted – VVS-installatør, varme & bad',
    meta: {
      description: 'VVS\'er i Grindsted? Vi dækker Grindsted med VVS, varmepumper, fjernvarme, badeværelser og døgnvagt – 15 minutter fra vores værksted. Ring 75 33 12 76.',
      ogTitle: 'VVS Grindsted – VVS-installatør, varme & bad',
      ogDescription: 'VVS\'er i Grindsted? Vi dækker Grindsted med VVS, varmepumper, fjernvarme, badeværelser og døgnvagt – 15 minutter fra vores værksted. Ring 75 33 12 76.'
    }
  },

  // 52. EN Plumber Grindsted
  'en-plumber-grindsted': {
    slug: 'en-plumber-grindsted',
    route: '/en/plumber-grindsted',
    lang: 'en',
    title: 'Plumber Grindsted – plumbing, heating & bathrooms',
    meta: {
      description: 'Need a plumber in Grindsted? Billund Varme & Sanitet covers Grindsted with plumbing, heat pumps, district heating, bathrooms and 24/7 emergency service – 15 minutes from our workshop.',
      ogTitle: 'Plumber Grindsted – plumbing, heating & bathrooms',
      ogDescription: 'Need a plumber in Grindsted? Billund Varme & Sanitet covers Grindsted with plumbing, heat pumps, district heating, bathrooms and 24/7 emergency service – 15 minutes from our workshop.'
    }
  },

  // 53. VVS Give
  'vvs-give': {
    slug: 'vvs-give',
    route: '/vvs-give',
    lang: 'da',
    title: 'VVS Give – VVS\'er til bolig, landbrug & erhverv',
    meta: {
      description: 'Lokal VVS-installatør i Give og omegn. VVS, varmepumper, badeværelser, blikkenslager og døgnvagt – 20 minutter fra Give. Få et tilbud på 75 33 12 76.',
      ogTitle: 'VVS Give – VVS\'er til bolig, landbrug & erhverv',
      ogDescription: 'Lokal VVS-installatør i Give og omegn. VVS, varmepumper, badeværelser, blikkenslager og døgnvagt – 20 minutter fra Give. Få et tilbud på 75 33 12 76.'
    }
  },

  // 54. EN Plumber Give
  'en-plumber-give': {
    slug: 'en-plumber-give',
    route: '/en/plumber-give',
    lang: 'en',
    title: 'Plumber Give – plumbing for homes, farms & business',
    meta: {
      description: 'Local plumber for Give and the surrounding area. Plumbing, heat pumps, bathrooms, sheet metal and 24/7 emergency service from Billund Varme & Sanitet – 20 minutes from Give.',
      ogTitle: 'Plumber Give – plumbing for homes, farms & business',
      ogDescription: 'Local plumber for Give and the surrounding area. Plumbing, heat pumps, bathrooms, sheet metal and 24/7 emergency service from Billund Varme & Sanitet – 20 minutes from Give.'
    }
  },

  // 55. VVS Vejle
  'vvs-vejle': {
    slug: 'vvs-vejle',
    route: '/vvs-vejle',
    lang: 'da',
    title: 'VVS Vejle – VVS-installatør fra Billund Varme & Sanitet',
    meta: {
      description: 'VVS\'er til Vejle og omegn med fast pris og 60+ års erfaring. Varmepumper, badeværelser, blikkenslager, erhverv og nybyggeri. Ring 75 33 12 76.',
      ogTitle: 'VVS Vejle – VVS-installatør fra Billund Varme & Sanitet',
      ogDescription: 'VVS\'er til Vejle og omegn med fast pris og 60+ års erfaring. Varmepumper, badeværelser, blikkenslager, erhverv og nybyggeri. Ring 75 33 12 76.'
    }
  },

  // 56. EN Plumber Vejle
  'en-plumber-vejle': {
    slug: 'en-plumber-vejle',
    route: '/en/plumber-vejle',
    lang: 'en',
    title: 'Plumber Vejle – from Billund Varme & Sanitet',
    meta: {
      description: 'Plumber for Vejle and the surrounding area with fixed prices and 60+ years of experience. Heat pumps, bathrooms, sheet metal, commercial service and new builds. Call +45 75 33 12 76.',
      ogTitle: 'Plumber Vejle – from Billund Varme & Sanitet',
      ogDescription: 'Plumber for Vejle and the surrounding area with fixed prices and 60+ years of experience. Heat pumps, bathrooms, sheet metal, commercial service and new builds. Call +45 75 33 12 76.'
    }
  },

  // 57. VVS Sdr. Omme & Vorbasse
  'vvs-soender-omme': {
    slug: 'vvs-soender-omme',
    route: '/vvs-soender-omme',
    lang: 'da',
    title: 'VVS Sdr. Omme, Vorbasse & Hejnsvig | Billund VVS',
    meta: {
      description: 'VVS\'er til Sdr. Omme, Vorbasse, Hejnsvig og Filskov. Lokal VVS-installatør fra Billund med varmepumper, bad, blik, landbrug og døgnvagt. Ring 75 33 12 76.',
      ogTitle: 'VVS Sdr. Omme, Vorbasse & Hejnsvig | Billund VVS',
      ogDescription: 'VVS\'er til Sdr. Omme, Vorbasse, Hejnsvig og Filskov. Lokal VVS-installatør fra Billund med varmepumper, bad, blik, landbrug og døgnvagt. Ring 75 33 12 76.'
    }
  },

  // 58. EN Plumber Sdr. Omme & Vorbasse
  'en-plumber-soender-omme': {
    slug: 'en-plumber-soender-omme',
    route: '/en/plumber-soender-omme',
    lang: 'en',
    title: 'Plumber Sdr. Omme, Vorbasse & Hejnsvig | Billund VVS',
    meta: {
      description: 'Plumber for Sdr. Omme, Vorbasse, Hejnsvig and Stenderup-Krogager. Local plumbing contractor from Billund with heat pumps, bathrooms, sheet metal, agriculture and 24/7 emergency service.',
      ogTitle: 'Plumber Sdr. Omme, Vorbasse & Hejnsvig | Billund VVS',
      ogDescription: 'Plumber for Sdr. Omme, Vorbasse, Hejnsvig and Stenderup-Krogager. Local plumbing contractor from Billund with heat pumps, bathrooms, sheet metal, agriculture and 24/7 emergency service.'
    }
  }
};
